<template>
  <div class="home">
    <video
      style="
        position: absolute;
        top: -96px;
        width: 100%;
        height: 100vh;
        object-fit: cover;
        z-index: 0;
      "
      :src="
        'http://nncms.actstudio.xyz/storage/uploads/' + home.videoFondo.path
      "
      autoplay
      loop
      muted
    ></video>

    <!-- Bloque presentacion -->
    <div style="z-index: 1; position: relative; background-color: #5c27b2a6">
      <v-container class="py-0">
        <v-row style="height: 200px" align="center">
          <v-col>
            <v-img
              src="../assets/img/neutralnetworks_blanco.svg"
              width="300"
            ></v-img>
          </v-col>
        </v-row>
        <v-row style="height: calc(100vh - 96px - 300px)" align="center">
          <v-col cols="12">
            <v-carousel
              :hide-delimiters="true"
              :show-arrows="false"
              cycle
              height="250"
            >
              <v-carousel-item
                v-for="(texto, textoID) in home.textosIniciales"
                :key="'id' + textoID"
                transition="fade-transition"
                reverse-transition="fade-transition"
              >
                <span
                  class="montserrat bold enfasis-size d-none d-sm-block"
                  style="white-space: pre"
                  >{{ texto.value }}</span
                >
                <span class="montserrat bold enfasis-size d-sm-none">{{
                  texto.value
                }}</span>
              </v-carousel-item>
            </v-carousel>
            <div class="home-intro-descipcion">
              <hr class="mb-6 color-blanco home-intro-descipcion-line"/>
              <span class="montserrat  single-item-size line-height-1 d-none d-sm-block">
                Somos una empresa dedicada a proporcionar infraestructura 100%
                neutra a todo tipo de operadores de telecomunicaciones, a través
                de arrendamiento de fibra oscura y metro ethernet.
              </span>
              
            </div>
          </v-col>
        </v-row>
        <v-row style="height: 100px">
          <v-col>
            <v-img
              src="../assets/img/an-evengroup-company_logo-blanco.svg"
              width="255"
              :contain="true"
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- Termina bloque presentacion -->

    <!-- Neutral Networks en números -->
    <v-container class="py-12">
      <v-row>
        <v-col class="text-center">
          <template v-if="lang == 'es'">
            <span class="montserrat bold titulos-size color-morado"
              >Neutral Networks en Números</span
            >
          </template>
          <template v-else>
            <span class="montserrat bold titulos-size color-morado"
              >Neutral Networks en Números</span
            >
          </template>
        </v-col>
      </v-row>

      <v-row align-md="center">
        <v-col
          v-for="(item, enNumerosID) in home.enNumeros"
          cols="6"
          md="4"
          :key="'enNumeros' + enNumerosID"
          class="text-center my-7 home-cards"
        >
          <div class="home-cards--content-img">
            <v-img
              :src="'http://nncms.actstudio.xyz' + item.value.icono.path"
              width="90"
              class="mx-auto mb-4"
            ></v-img>
          </div>

          <div class="home-cards--content">
            <template v-if="item.value.primerTextoRegular != ''">
              <span
                class="d-inline-block color-morado"
                style="font-size: 18px"
                >{{ item.value.primerTextoRegular }}</span
              >
            </template>
            <template v-if="item.value.primerTextoBold != ''">
              <span
                class="d-inline-block color-morado"
                style="font-size: 28px"
                >{{ item.value.primerTextoBold }}</span
              >
            </template>
            <span class="d-block color-morado" style="font-size: 18px">{{
              item.value.segundoTexto
            }}</span>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina Neutral Networks en números -->

    <!-- Inicia mapa -->
    <div class="d-none d-md-block">
      <MapaHome></MapaHome>
    </div>
    <!-- Termina mapa -->

    <!-- Inicia Productos -->
    <v-container class="my-12">
      <v-row>
        <v-col class="text-center">
          <span class="montserrat bold titulos-size color-morado"
            >Productos</span
          >
        </v-col>
      </v-row>

      <v-row class="pa-0">
        <v-col class="pa-0 px-12">
          <Splide :options="options" :slides="destacados">
            <SplideSlide
              v-for="(destacado, d) in destacados"
              :key="'destacado-' + d"
            >
              <v-row>
                <v-col class="px-0">
                  <v-card color="#5C27B2" dark height="430" class="mx-2">
                    <v-img
                      class="white--text align-end"
                      height="120px"
                      :src="
                        'http://nncms.actstudio.xyz' +
                        destacado.imagenCover.path
                      "
                    ></v-img>

                    <v-card-text class="text-center px-md-5">
                      <div class="home-card-content">
                        <span
                          class="d-block bold titulos-size uppercase my-3 color-blanco"
                          >{{ destacado.name }}</span
                        >
                        <p
                          class="texto-corrido-size my-6 color-blanco home-card-descripcionCorta"
                        >
                          {{ destacado.descripcionCorta }}
                        </p>
                      </div>
                      <v-btn
                        :to="'/servicios/' + destacado.url"
                        class="my-6"
                        outlined
                        width="210"
                        height="35"
                      >
                        Ver más
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </SplideSlide>
          </Splide>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina Productos -->

    <!-- Por qué Neutral Networks? -->
    <v-container class="my-5">
      <v-row>
        <v-col class="text-center">
          <span class="montserrat bold titulos-size color-morado"
            >¿Por qué Neutral Networks?</span
          >
        </v-col>
      </v-row>

      <v-row justify="center" class="mb-12 py-0">
        <v-col cols="12" sm="auto" class="py-0">
          <v-carousel
            :dark="false"
            :show-arrows="false"
            :hide-delimiter-background="true"
            light
            height="450"
          >
            <v-carousel-item
              v-for="(item, index) in home.porqueNN"
              :key="index"
            >
              <v-row
                justify="center"
                class="color-morado text-center"
                align="center"
                style="height: 390px"
              >
                <v-col cols="auto" sm="3" md="3" lg="3" xl="2" class="px-6">
                  <v-img
                    :src="
                      'https://nncms.actstudio.xyz/' + item.value.imagen.path
                    "
                    class="home-carousel--img"
                  ></v-img>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                  xl="4"
                  class="text-left px-6"
                >
                  <p>{{ item.value.descripcion }}</p>
                </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>

    <div style="background-size: cover; position: relative">
      <div style="position: absolute; width: 100%; height: 100%; z-index: 0">
        <video
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 0;
          "
          :src="
            'http://nncms.actstudio.xyz/storage/uploads/' + home.videoFondo.path
          "
          autoplay
          loop
          muted
        ></video>
      </div>
      <div style="background: #5c27b2a6; position: relative">
        <v-container>
          <v-row class="py-10">
            <v-col class="text-center">
              <span class="montserrat bold enfasis-size color-blanco"
                >Nuestra Oferta de Valor</span
              >
            </v-col>
          </v-row>
          <v-row align="center" style="height: 330px">
            <v-col
              cols="12"
              md="4"
              class="text-center"
              v-for="(oferta, ofertaID) in home.ofertasDeValor"
              :key="'ofertaValor' + ofertaID"
            >
              <v-icon color="white">mdi-plus</v-icon>
              <span
                class="montserrat bold color-blanco enfasis-size valign-middle"
                >{{ oferta.value }}</span
              >
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- Termina nuestra oferta de valor -->
  </div>
</template>


<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
export default {
  name: "Home",
  data() {
    return {
      home: {
        imagenOfertaValor: {
          path: "",
        },
        videoFondo: {
          path: "",
        },
      },
      destacados: [],
      options: {
        width: "100%",
        rewind: true,
        type: "loop",
        pagination: false,
        // arrowPath:'../assets/img/left_slide.svg',
        perPage: 4,
        perMove: 1,
        gap: 30,
        trimSpace: true,
        breakpoints: {
          600: {
            perPage: 1,
          },
          960: {
            perPage: 2,
          },
          1264: {
            perPage: 3,
          },
          1904: {
            perPage: 4,
          },
        },
      },
    };
  },
  components: {
    MapaHome: () => import("../components/MapaHome.vue"),
    Splide,
    SplideSlide,
  },
  mounted: function () {
    fetch(
      "http://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401"
    )
      .then((data) => data.json())
      .then((data) => (this.home = data));

    fetch(
      "http://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            destacado: true,
            activo: true,
          },
          sort: { _o: 1 },
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.destacados = res.entries));
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  watch: {
    lang() {
      if (this.$i18n.locale == "en") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "http://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "eng",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.home = data));

        fetch(
          "http://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                destacado: true,
                activo: true,
              },
              sort: { _o: 1 },
              populate: 1, // resolve linked collection items
              lang: "eng",
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.destacados = res.entries));
      } else if (this.$i18n.locale == "es") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "http://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401"
        )
          .then((data) => data.json())
          .then((data) => (this.home = data));
        fetch(
          "http://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                destacado: true,
                activo: true,
              },
              sort: { _o: 1 },
              populate: 1, // resolve linked collection items
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.destacados = res.entries));
      }
    },
  },
};
</script>
